/**
 * @generated SignedSource<<93ac74635353cc0e517c0be89ef6b02b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rankingType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useOnlyCategories",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "category",
    "variableName": "category"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPoints",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousPosition",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundsPlayed",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tournamentId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RankingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "RankingTable_ranking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamRankingTable_ranking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeamplayRankingTable_ranking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RankingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Ranking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rankingTournamentsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "RankingPlayer",
            "kind": "LinkedField",
            "name": "rankingPlayers",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Player",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nationality",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "categoryPosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousCategoryPosition",
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RankingPlayerRound",
                "kind": "LinkedField",
                "name": "rankingPlayerRounds",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isIncluded",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sortedTournaments",
            "args": [
              {
                "kind": "Literal",
                "name": "sortBy",
                "value": "start_date"
              },
              {
                "kind": "Literal",
                "name": "sortDirection",
                "value": "asc"
              }
            ],
            "concreteType": "RankingTournament",
            "kind": "LinkedField",
            "name": "rankingTournaments",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": "rankingTournaments(sortBy:\"start_date\",sortDirection:\"asc\")"
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RankingEntry",
            "kind": "LinkedField",
            "name": "rankingEntries",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organisation",
                "kind": "LinkedField",
                "name": "organisation",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RankingEntryRound",
                "kind": "LinkedField",
                "name": "rankingEntryRounds",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasActiveTournament",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RankedTeamplay",
            "kind": "LinkedField",
            "name": "rankedTeamplays",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gameDiff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamesLost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gamesWon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchDiff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchesLost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchesWon",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "played",
                "storageKey": null
              },
              (v14/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "won",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52881c87b36c98ab89330c9f34688dc2",
    "id": null,
    "metadata": {},
    "name": "RankingQuery",
    "operationKind": "query",
    "text": "query RankingQuery(\n  $category: String\n  $id: ID!\n) {\n  ranking(id: $id) {\n    databaseId\n    rankingType\n    useOnlyCategories\n    ...RankingTable_ranking_15BdcN\n    ...TeamRankingTable_ranking\n    ...TeamplayRankingTable_ranking\n    id\n  }\n}\n\nfragment RankingTableEntry_ranking on Ranking {\n  useOnlyCategories\n  sortedTournaments: rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n    id\n    tournamentId\n  }\n}\n\nfragment RankingTableEntry_rankingPlayer on RankingPlayer {\n  category\n  categoryPoints\n  categoryPosition\n  position\n  previousCategoryPosition\n  previousPosition\n  roundsPlayed\n  score\n  player {\n    firstName\n    lastName\n    nationality\n    id\n  }\n  rankingPlayerRounds {\n    categoryPoints\n    isIncluded\n    tournamentId\n    score\n    id\n  }\n}\n\nfragment RankingTable_ranking_15BdcN on Ranking {\n  rankingTournamentsCount\n  rankingPlayers(category: $category) {\n    position\n    player {\n      databaseId\n      name\n      id\n    }\n    ...RankingTableEntry_rankingPlayer\n    id\n  }\n  ...RankingTableEntry_ranking\n  id\n}\n\nfragment TeamRankingTableEntry_ranking on Ranking {\n  sortedTournaments: rankingTournaments(sortBy: \"start_date\", sortDirection: \"asc\") {\n    id\n    tournamentId\n  }\n}\n\nfragment TeamRankingTableEntry_rankingEntry on RankingEntry {\n  position\n  previousPosition\n  roundsPlayed\n  points\n  organisation {\n    name\n    id\n  }\n  rankingEntryRounds {\n    tournamentId\n    points\n    id\n  }\n}\n\nfragment TeamRankingTable_ranking on Ranking {\n  rankingTournamentsCount\n  rankingEntries {\n    databaseId\n    position\n    ...TeamRankingTableEntry_rankingEntry\n    id\n  }\n  ...TeamRankingTableEntry_ranking\n}\n\nfragment TeamplayRankingTable_ranking on Ranking {\n  hasActiveTournament\n  rankedTeamplays {\n    gameDiff\n    gamesLost\n    gamesWon\n    lost\n    matchDiff\n    matchesLost\n    matchesWon\n    name\n    played\n    points\n    position\n    tied\n    won\n  }\n}\n"
  }
};
})();

node.hash = "10da021ec601c65103295a5cec56d5f4";

module.exports = node;
